import { type AuthProvider } from "react-admin";

import { type components } from "@/api";
import { UserRole } from "@/constants";
import { HTTP_STATUS } from "@/constants/http";

import { apiClient, getAccessName, getIdentityFromCache } from "./utils";

const getPermissions = async (): Promise<string[]> => {
  const user = await getIdentityFromCache();

  return user.allRoles as string[];
};

export const authProvider: AuthProvider = {
  async login(loginParams) {
    const { username, password } = loginParams as {
      username: string;
      password: string;
    };
    const { data: { token = "" } = {} } = await apiClient.POST(
      "/api/main/login_check",
      {
        body: {
          password,
          username,
        },
      },
    );
    localStorage.setItem("token", token);
  },
  checkError(error) {
    const status = (error as { status?: number }).status;
    if (status === HTTP_STATUS.UNAUTHORIZED) {
      localStorage.removeItem("token");
      return Promise.reject(new Error("Session expired"));
    }
    return Promise.resolve();
  },
  checkAuth() {
    if (!localStorage.getItem("token")) {
      return Promise.reject(new Error("Not authenticated"));
    }
    return Promise.resolve();
  },
  logout() {
    localStorage.removeItem("token");
    return Promise.resolve();
  },
  async getIdentity({ signal } = {}) {
    // @ts-expect-error Ошибка типизации ответа со стороны бэка
    const { data } = (await apiClient.GET("/api/main/users/current", {
      signal,
    })) as {
      data: components["schemas"]["User-Read"];
    };

    return { ...data, fullName: data.username, id: data.id as number };
  },
  async canAccess({ resource, action }) {
    const permissions = await getPermissions();
    const actionName = getAccessName(resource, action);

    return (
      permissions.includes(UserRole.ADMIN) || permissions.includes(actionName)
    );
  },
  getPermissions,
  supportAbortSignal: true,
};
